import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from './services/auth-guard.service';

import { DashboardComponent } from './components/dashboard/dashboard.component';
import { UnsubscribeUserComponent } from './components/unsubscribe-user/unsubscribe-user.component';
import { NotFoundComponent } from './components/not-found/not-found.component';
import { InboxComponent } from './components/inbox/inbox.component';
import { GdprModalMessageComponent } from './components/gdpr-modal-message/gdpr-modal-message.component';
import { CompleteProfileComponent } from './components/complete-profile/complete-profile.component';
import { BuyerToSellerWrapperComponent } from './components/buyer-to-seller-wrapper/buyer-to-seller-wrapper.component';
import { LogoutComponent } from './components/logout/logout.component';
import { NonAuthGuard } from './services/non-auth-guard.service';
import {ConversationDetailsComponent} from './components/inbox/common/components/conversation-details/conversation-details.component';
import {PageNotAvailableComponent} from './components/page-not-available/page-not-available';
import {ZoomAuthLandingComponent} from './components/zoom-auth-landing/zoom-auth-landing.component';
import { LoginComponent } from './components/login/login.component';
import { OktaCallbackComponent } from './components/okta-callback/okta-callback.component';
import { OktaGuard } from './services/okta-guard.service';

const routes: Routes = [
    { path: '', redirectTo: 'dashboard', pathMatch: 'full', data: { breadcrumb: '' } },
    { path: 'login/callback', component: OktaCallbackComponent,  data: { breadcrumb: 'Okta Callback' }, canActivate: []  },
    { path: 'login', component: LoginComponent,  data: { breadcrumb: 'Login' }, canActivate: [NonAuthGuard]  },
    { path: 'logout',      component: LogoutComponent,  data: { breadcrumb: 'Logout' }, canActivate: [NonAuthGuard]  },
    { path: 'dashboard',        component: DashboardComponent,  data: { breadcrumb: 'Dashboard' }, canActivate: [OktaGuard]  },
    { path: 'updated-privacy-policy', component: GdprModalMessageComponent, data: { breadcrumb: 'Acknowledge New Privacy Policy'}},
    { path: 'onboarding', component: CompleteProfileComponent, data: { breadcrumb: 'Add menus'}},
    { path: 'unsubscribe-user/:uuid', component: UnsubscribeUserComponent, data: { breadcrumb: 'Unsubscribe User' } },
    { path: 'buyer/seller-signup', component: BuyerToSellerWrapperComponent, data: {breadcrumb: 'Become a Seller'}},
    { path: 'hw/admin/zoom-auth-landing', component: ZoomAuthLandingComponent},
    { path: 'inbox',  data: { breadcrumb: 'Inbox' }, children: [
        { path: '', component: InboxComponent, data: { breadcrumb: 'Inbox' } },
        { path: 'conversation/:id/details', component: ConversationDetailsComponent, data: { breadcrumb: 'Conversation Details' }},
        { path: 'conversation/:accountDomain/details/:accountName', component: ConversationDetailsComponent, data: { breadcrumb: 'Conversation Details' }}
    ]},
    { path: 'unauthorized',component: PageNotAvailableComponent,      data: { breadcrumb: 'Not Available' } },
    { path: '**',        component: NotFoundComponent,      data: { breadcrumb: 'Not Found' } },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CoreRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/core/core-routing.module.ts